import { Injectable } from '@angular/core';
import { CityService } from '@city/feature';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { AuthActions } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user';
import { User } from '@user/const';
import { CustomUserActions } from '@user/data-access';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take, tap } from 'rxjs/operators';
import { AnalyticsService, LoginAnalyticsGaService, RetailRocketService } from '../services';

@Injectable()
export class AuthAnalyticsEffects {
  setCustomer$: Observable<null> = createEffect(
    () =>
      this.actions$.pipe(
        ofType<AuthActions.Login>(AuthActions.LOGIN),
        switchMap(() => this.userAccountService.get().pipe(filter<User>(Boolean), take(1))),
        concatLatestFrom(() => this.cityService.activeBaseStoreCode$),
        tap(([{ customerId, phone, dateOfBirth, email, firstName, lastName, subscriptionDate }, defaultStockId]) => {
          const subscriptionDateFormatted = subscriptionDate && new Date(subscriptionDate).toISOString().split('T')[0];

          this.retailRocketService.setCustomer({
            customerId,
            email,
            phone,
            defaultStockId,
            customData: {
              name: firstName,
              surname: lastName,
              birth_date: dateOfBirth,
              subscriptionDate: subscriptionDateFormatted,
            },
          });
        }),
        map(() => null),
      ),
    { dispatch: false },
  );

  sendSmsSuccess$: Observable<void> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(CustomUserActions.REQUEST_AUTH_CODE_SUCCESS),
        tap(() => this.loginAnalyticsService.sendGa('click_getSMS_btn')),
      );
    },
    { dispatch: false },
  );

  onSuccessLogin$: Observable<User> = createEffect(
    () => {
      return this.actions$.pipe(
        ofType<AuthActions.Login>(AuthActions.LOGIN),
        switchMap(() => this.userAccountService.get().pipe(filter(Boolean), take(1))),
        tap(({ rosaUuid }) => {
          if (rosaUuid) {
            this.analyticsService.sendEvent({
              event: 'userlogin',
              loyalty_id: rosaUuid,
            });
          }
        }),
      );
    },
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private retailRocketService: RetailRocketService,
    private userAccountService: UserAccountFacade,
    private cityService: CityService,
    private loginAnalyticsService: LoginAnalyticsGaService,
    private analyticsService: AnalyticsService,
  ) {}
}
